export default {
  namespaced: true,
  seproban: {
    title: "seproban",
    id_alarm: "id alarm",
    path: "path",
    order: "orden de envío",
    is_send: "enviado",
    sent_at: "enviado a las",
    image: "Imagen",
    downloaded: "Descargado",
    downloaded_at: "Descargado el",
    sent_seproban: "Enviado a Seproban",
    sent_seproban_at: "Enviado a Seproban el",
    images: "Imagenes",
    send_seproban: "Enviar a seproban",
    fetching_images: "Obteniendo imágenes...",
    capture_completed: "Obtención de imágenes finalizada",
    uploading_images: "Enviando imágenes...",
    upload_finished: "Envío de imágenes finalizado",
    no_images_available: "No hay imágenes disponibles para esta cámara.",
    sending: "Enviando",
    total_images: "Total imágenes",
    generated_images: "Generadas",
    sent_images: "Enviadas",
    view_detail: "Ver detalle",
    all_downloaded_at: "Fecha de descarga completa",
    all_sent_at: "Fecha de envío completo",
    image_details: "Detalles de imágenes Seproban",
    event_id: "ID del evento Seproban",
    alarm_id: "ID de la alarma",
    alarm_created_at: "Fecha de creación de la alarma",
    unit: "Unidad",
    first_download_at: "Fecha de primera descarga",
    last_download_at: "Fecha de última descarga",
    first_sent_at: "Fecha del primer envío",
    last_sent_at: "Fecha del último envío",
    send_rate: "Tasa de envío",
    images_per_second: "imágenes/s",
    download_date_range: "Rango de fecha de descarga",
    sent_date_range: "Rango de fecha de envío",
    generating_images: "Generando imágenes...",
 }
}
